 <div class="popup-overlay" id="deletePopup">
        <div class="popup-dialog">
            <h3 class="popup-title">Delete Item</h3>
            <p class="popup-message">Are you sure you want to remove "<span id="itemName"></span>" from your cart?</p>
            <div class="popup-buttons">
                <button class="popup-btn popup-btn-delete" (click)="confirmDelete()">Yes, Delete</button>
                <button class="popup-btn popup-btn-cancel" (click)="hideDeletePopup()">Cancel</button>
            </div>
        </div>
    </div>